import {
  TaxCategoryCodeSchema,
  type TaxCategoryCode as GeneratedTaxCategoryCode
} from '~/services/api/generated'

// Mirrors backend App\Enums\Tax\TaxCategoryCode

export type TaxCategoryCode = GeneratedTaxCategoryCode

export const TaxCategoryCode = {
  FOOD_AND_NON_ALCOHOLIC_BEVERAGES: TaxCategoryCodeSchema.enum.FOOD_AND_NON_ALCOHOLIC_BEVERAGES,
  ALCOHOLIC_BEER_OR_MALT_BEVERAGE: TaxCategoryCodeSchema.enum.ALCOHOLIC_BEER_OR_MALT_BEVERAGE,
  ALCOHOLIC_SPIRITS: TaxCategoryCodeSchema.enum.ALCOHOLIC_SPIRITS,
  ALCOHOLIC_WINE: TaxCategoryCodeSchema.enum.ALCOHOLIC_WINE
} satisfies Record<string, GeneratedTaxCategoryCode>

export const TaxCategoryCodeValues: readonly GeneratedTaxCategoryCode[] =
  Object.values(TaxCategoryCode)

/**
 * Frontend-owned display labels + grouping for the item tax-category selector.
 */
export const TAX_CATEGORY_GROUPS: readonly {
  group: string
  items: readonly { tax_category: GeneratedTaxCategoryCode; label: string }[]
}[] = [
  {
    group: 'Food & Non-Alcoholic Drinks',
    items: [
      {
        tax_category: TaxCategoryCode.FOOD_AND_NON_ALCOHOLIC_BEVERAGES,
        label: 'Food & Non-Alcoholic Beverages'
      }
    ]
  },
  {
    group: 'Alcoholic Drinks',
    items: [
      {
        tax_category: TaxCategoryCode.ALCOHOLIC_BEER_OR_MALT_BEVERAGE,
        label: 'Beer/Malt Beverage'
      },
      { tax_category: TaxCategoryCode.ALCOHOLIC_SPIRITS, label: 'Liquor/Spirits' },
      { tax_category: TaxCategoryCode.ALCOHOLIC_WINE, label: 'Wine' }
    ]
  }
]
